/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import fs from 'fs-extra';
import globby from 'globby';
import { StaticAssetInput } from './types';
import { resolveSafeChildPath } from '@backstage/backend-plugin-api';

/**
 * Finds all static assets within a directory
 *
 * @internal
 */
export async function findStaticAssets(
  staticDir: string,
): Promise<StaticAssetInput[]> {
  const assetPaths = await globby('**/*', {
    ignore: ['**/*.map'], // Ignore source maps since they're quite large
    cwd: staticDir,
    dot: true,
  });

  return assetPaths.map(path => ({
    path,
    content: async () => fs.readFile(resolveSafeChildPath(staticDir, path)),
  }));
}
